export default __webpack_public_path__ + "static/media/image-ph-health-alarm-m.9225d7f1.webp";